/**
 * Reveals PDP buybox when productBuyBox is ready. Yotpo review rows reveal independently when stable.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('[data-pdp-buybox-shell]').forEach(function (shell) {
      shell.classList.remove('is-loading');
      shell.classList.add('is-ready');
    });
    document.querySelectorAll('[data-pdp-yotpo-rating-wrap]').forEach(function (wrap) {
      wrap.classList.add('is-stable');
      wrap.removeAttribute('aria-hidden');
    });
    document.documentElement.classList.add('pdp-buybox-loaded');
    return;
  }

  var shells = document.querySelectorAll('[data-pdp-buybox-shell]');
  if (!shells.length) return;

  var revealed = false;

  function applyFinalStyles() {
    if (typeof window.pdpApplyFinalSalePriceStyles === 'function') {
      window.pdpApplyFinalSalePriceStyles();
    }
    if (typeof window.pdpApplyFinalSalePriceLabel === 'function') {
      window.pdpApplyFinalSalePriceLabel();
    }
    if (typeof window.updateFinalSaleLabel === 'function') {
      window.updateFinalSaleLabel();
    }
  }

  function hasYotpoRatingContent(wrap) {
    var bottomLine = wrap.querySelector('.yotpo.bottomLine, .yotpo-bottomline');
    if (!bottomLine) return false;

    if (
      bottomLine.querySelector(
        '.yotpo-icon-star, .yotpo-icon-half-star, .yotpo-icon-empty-star, .yotpo-sr-star-full, .yotpo-sr-star-half, .star-container, .yotpo-stars, a.text-m, .yotpo-sr-bottom-line-text'
      )
    ) {
      return true;
    }

    var text = (bottomLine.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 0;
  }

  function markYotpoWrapStable(wrap) {
    if (!wrap || wrap.classList.contains('is-stable')) return;
    wrap.classList.add('is-stable');
    wrap.removeAttribute('aria-hidden');
  }

  function initYotpoRatingStability() {
    document.querySelectorAll('[data-pdp-yotpo-rating-wrap]').forEach(function (wrap) {
      if (wrap.dataset.pdpYotpoStabilityInit === 'true') return;
      wrap.dataset.pdpYotpoStabilityInit = 'true';

      var stableTimer = null;
      var done = false;
      var observer = null;

      function markStable() {
        if (done) return;
        if (!hasYotpoRatingContent(wrap)) return;
        done = true;
        if (observer) observer.disconnect();
        clearTimeout(stableTimer);
        markYotpoWrapStable(wrap);
      }

      function scheduleStableCheck() {
        clearTimeout(stableTimer);
        stableTimer = setTimeout(markStable, 600);
      }

      function forceStable() {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        clearTimeout(stableTimer);
        markYotpoWrapStable(wrap);
      }

      if (hasYotpoRatingContent(wrap)) {
        scheduleStableCheck();
      }

      observer = new MutationObserver(scheduleStableCheck);
      observer.observe(wrap, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      setTimeout(forceStable, 8000);

      if (window.yotpo && typeof window.yotpo.ready === 'function') {
        window.yotpo.ready(scheduleStableCheck);
      } else {
        var yotpoAttempts = 0;
        var yotpoPoll = setInterval(function () {
          yotpoAttempts += 1;
          if (window.yotpo && typeof window.yotpo.ready === 'function') {
            clearInterval(yotpoPoll);
            window.yotpo.ready(scheduleStableCheck);
          } else if (yotpoAttempts > 80) {
            clearInterval(yotpoPoll);
          }
        }, 100);
      }
    });
  }

  function revealBuybox() {
    if (revealed) return;
    revealed = true;

    applyFinalStyles();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        applyFinalStyles();

        shells.forEach(function (shell) {
          shell.classList.remove('is-loading');
          shell.classList.add('is-ready');
        });

        document.documentElement.classList.add('pdp-buybox-loaded');
        document.dispatchEvent(new CustomEvent('pdp:buyboxRevealed'));
        initYotpoRatingStability();
      });
    });
  }

  function isBuyboxReady() {
    var pb = window.eHS && window.eHS.productBuyBox;
    return !!(pb && pb.product && pb.currentVariant);
  }

  function onDataReady() {
    applyFinalStyles();
    setTimeout(function () {
      applyFinalStyles();
      revealBuybox();
    }, 150);
  }

  function waitForReady() {
    if (isBuyboxReady()) {
      onDataReady();
      return;
    }

    document.addEventListener('pdp:buyboxDataReady', onDataReady, { once: true });

    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      if (isBuyboxReady()) {
        clearInterval(poll);
        onDataReady();
      } else if (attempts > 160) {
        clearInterval(poll);
        revealBuybox();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForReady);
  } else {
    waitForReady();
  }

  setTimeout(function () {
    if (!revealed) revealBuybox();
  }, 10000);
})();
